module.exports = __webpack_public_path__ + "img/aws.d7b6c3da.png";